/* eslint-disable */
import faker from 'faker';
import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useRef, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { set, sub, formatDistanceToNow } from 'date-fns';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import clockFill from '@iconify/icons-eva/clock-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
// material
import { alpha } from '@material-ui/core/styles';
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  IconButton,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton
} from '@material-ui/core';
// utils
import { mockImgAvatar } from '../../utils/mockImages';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import { useNavigate } from 'react-router-dom';
import services from '../../../src/components/authentication/login/Service';
import TokenDecoder from 'src/helpers/TokenDecoder';
// ----------------------------------------------------------------------

const NOTIFICATIONS = [
  {
    id: faker.datatype.uuid(),
    title: 'Your order is placed',
    description: 'waiting for shipping',
    avatar: null,
    type: 'order_placed',
    createdAt: set(new Date(), { hours: 10, minutes: 30 }),
    isUnRead: true
  },
  {
    id: faker.datatype.uuid(),
    title: faker.name.findName(),
    description: 'answered to your comment on the Minimal',
    avatar: mockImgAvatar(2),
    type: 'friend_interactive',
    createdAt: sub(new Date(), { hours: 3, minutes: 30 }),
    isUnRead: true
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new message',
    description: '5 unread messages',
    avatar: null,
    type: 'chat_message',
    createdAt: sub(new Date(), { days: 1, hours: 3, minutes: 30 }),
    isUnRead: false
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new mail',
    description: 'sent from Guido Padberg',
    avatar: null,
    type: 'mail',
    createdAt: sub(new Date(), { days: 2, hours: 3, minutes: 30 }),
    isUnRead: false
  },
  {
    id: faker.datatype.uuid(),
    title: 'Delivery processing',
    description: 'Your order is being shipped',
    avatar: null,
    type: 'order_shipped',
    createdAt: sub(new Date(), { days: 3, hours: 3, minutes: 30 }),
    isUnRead: false
  }
];

function renderContent(notification) {
  const title = (
    <>
      <Typography variant="subtitle2">
        {notification.notificationTitle}
      </Typography>
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        {noCase(notification.notificationContent)}
      </Typography>
    </>
  );

  return {
    title
  };
}



export default function NotificationsPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [state, setState] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    GetAvailableNotification();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      GetAvailableNotification();
      setState(state + 1)
    }, 30000);
  }, [state]);

  async function handleMarkAllAsRead() {
    notifications.forEach(x => {
      x.modifiedBy = parseInt(TokenDecoder.getUserIDFromToken())
    })
    await services.NotificationMarkAsRead(notifications);
    GetAvailableNotification()
    setOpen(false);
  }

  NotificationItem.propTypes = {
    notification: PropTypes.object.isRequired
  };

  const navigate = useNavigate();

  async function GetAvailableNotification() {
    var details = await services.GetAvailableNotification();
    setNotifications(details)
  }

  async function navigateToDirection(notification) {
    if (notification.notificationTitle === "Add Approved Price") {
      // navigate('/dashboard/priceUpdate');
      let array = [];
      array.push(notification)
      array.forEach(x => {
        x.modifiedBy = parseInt(TokenDecoder.getUserIDFromToken())
      })
      await services.NotificationMarkAsRead(array);
      GetAvailableNotification();
      setOpen(false);
    }
    else {
      // navigate('/dashboard/priceOrderUpdate');
      let array = [];
      array.push(notification)
      array.forEach(x => {
        x.modifiedBy = parseInt(TokenDecoder.getUserIDFromToken())
      })
      await services.NotificationMarkAsRead(array);
      GetAvailableNotification();
      setOpen(false);
    }

  }

  function NotificationItem({ notification }) {
    return (
      <ListItemButton
        to="#"
        disableGutters
        onClick={() => navigateToDirection(notification)}
        sx={{
          py: 1.5,
          px: 2.5,
          mt: '1px',
          ...(notification.isUnRead && {
            bgcolor: 'action.selected'
          })
        }}
      >
        <ListItemText
          primary={notification.title}
          secondary={
            <>
              <Typography
                variant="body2"
                color="text.primary"
                sx={{ display: 'block', whiteSpace: 'pre-wrap' }}
              >
                {notification.notificationContent}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  color: 'text.disabled'
                }}
              >
                <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
                {formatDistanceToNow(new Date(notification.createdDate))}
              </Typography>
            </>
          }
        />
      </ListItemButton>
    );
  }


  return (
    <>
      <IconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Badge badgeContent={notifications.length} color="error">
          <Icon icon={bellFill} width={20} height={20} />
        </Badge>
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 360, height: 600 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifications</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              You have {notifications.length} unread messages
            </Typography>
          </Box>

          {notifications.length > 0 && (
            <Tooltip title=" Mark all as read">
              <IconButton color="primary" onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Divider />
        <Scrollbar sx={{ height: { xs: 340, sm: 500 } }}>
          {notifications.length > 0 ?
            <List
              disablePadding
              subheader={
                <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                  New
                </ListSubheader>
              }
            >
              {notifications.map((notification) => (
                <NotificationItem key={notification.id} notification={notification} />
              ))}
            </List>
            : null}
        </Scrollbar>
        <Divider />
      </MenuPopover>
    </>
  );
}
